import { render, staticRenderFns } from "./LayersTreeItemGroup.vue?vue&type=template&id=10d1c01b&scoped=true"
import script from "./LayersTreeItemGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersTreeItemGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LayersTreeItemGroup.vue?vue&type=style&index=0&id=10d1c01b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1c01b",
  null
  
)

export default component.exports